import { MenuItem, TextField } from "@mui/material";
import type { FieldValues, ValidationRule } from "react-hook-form";
import { Controller } from "react-hook-form";
import type { FormComponentProps } from "./FormComponentProps";

interface SelectOption {
  readonly value: string | number;
  readonly label: string | number;
}

export interface FormSelectRules<TFieldValues extends FieldValues = FieldValues> {
  required?: ValidationRule<boolean>;
  validate?: (value: string | number, formValues: TFieldValues) => boolean | string;
}

interface FormSelectProps<TFieldValues extends FieldValues = FieldValues> extends FormComponentProps<TFieldValues> {
  readonly options: SelectOption[];
  readonly margin?: "dense" | "none" | "normal";
  readonly rules?: FormSelectRules<TFieldValues>;
}

function FormSelect<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  options,
  rules,
  disabled,
  margin,
}: FormSelectProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          helperText={error ? error.message : null}
          error={!!error}
          onChange={onChange}
          value={options.length > 0 && value ? value : ""}
          fullWidth
          label={label}
          select
          disabled={disabled}
          margin={margin}
        >
          {options.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
}

export default FormSelect;
